import PropTypes from "prop-types";
import React from "react";
import { Card, Col, Row } from "react-bootstrap";

export const TestimonialCard = ({ testimonial, compact = false }) => {
  if (compact) {
    return (
      <div className="testimonial-compact">
        <div className="testimonial-quote">
          &ldquo;{testimonial.quote}&rdquo;
        </div>
        <div className="testimonial-author">- {testimonial.author}</div>
      </div>
    );
  }

  return (
    <Card className="testimonial-card">
      <Card.Body>
        <div className="testimonial-stars">
          {"⭐".repeat(testimonial.rating || 5)}
        </div>
        <blockquote className="testimonial-quote">
          &ldquo;{testimonial.quote}&rdquo;
        </blockquote>
        <div className="testimonial-author">
          <strong>{testimonial.author}</strong>
          {testimonial.location && (
            <span className="author-location"> - {testimonial.location}</span>
          )}
          {testimonial.puppyName && (
            <span className="puppy-name">
              {" "}
              (Owner of {testimonial.puppyName})
            </span>
          )}
        </div>
        {testimonial.date && (
          <div className="testimonial-date">{testimonial.date}</div>
        )}
      </Card.Body>
    </Card>
  );
};

TestimonialCard.propTypes = {
  testimonial: PropTypes.shape({
    quote: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    location: PropTypes.string,
    puppyName: PropTypes.string,
    rating: PropTypes.number,
    date: PropTypes.string,
  }).isRequired,
  compact: PropTypes.bool,
};

export const TestimonialSection = () => {
  const testimonials = [
    {
      quote:
        "Todo's Translator transformed our lives! Luna came to us fully trained and has been the perfect addition to our family. The training was so comprehensive that we had zero adjustment period.",
      author: "Sarah & Mike Johnson",
      location: "Denver, CO",
      puppyName: "Luna",
      rating: 5,
      date: "March 2024",
    },
    {
      quote:
        "After trying to train our previous dog ourselves, we knew we wanted a professional approach. The investment was worth every penny - our puppy Max is incredibly well-behaved and confident.",
      author: "Jennifer Chen",
      location: "Portland, OR",
      puppyName: "Max",
      rating: 5,
      date: "February 2024",
    },
    {
      quote:
        "The lifetime support has been incredible. Even months later, I can call with questions and get expert advice. This program truly sets you up for success.",
      author: "David Rodriguez",
      location: "Austin, TX",
      puppyName: "Bella",
      rating: 5,
      date: "January 2024",
    },
  ];

  return (
    <div className="testimonial-section">
      <h3 className="testimonial-title">What Our Families Say</h3>
      <Row className="g-4">
        {testimonials.map((testimonial, index) => (
          <Col key={index} md={4}>
            <TestimonialCard testimonial={testimonial} />
          </Col>
        ))}
      </Row>
    </div>
  );
};
